"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailState = void 0;
var MortgageState_init_1 = require("@/pages/common/states/MortgageState.init");
var NearbymapState_init_1 = require("@/pages/common/states/NearbymapState.init");
var DetailBuildingInfoState_init_1 = require("@/pages/detail/states/DetailBuildingInfoState.init");
var DetailDistrictInfoState_init_1 = require("@/pages/detail/states/DetailDistrictInfoState.init");
var DetailGalleryState_init_1 = require("@/pages/detail/states/DetailGalleryState.init");
var DetailPopNearbyTabType_1 = require("@/pages/detail/states/DetailPopNearbyTabType");
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var DetailTranslate_init_1 = require("@/pages/detail/states/DetailTranslate.init");
var PropertyAgent_init_1 = require("@/pages/detail/states/PropertyAgent.init");
var ResultItemDetail_init_1 = require("@/pages/detail/states/ResultItemDetail.init");
var BuildingState_init_1 = require("@/pages/place/states/BuildingState.init");
var PlaceAvailableState_init_1 = require("@/pages/place/states/PlaceAvailableState.init");
var NearbyCommuteEstimatorState_init_1 = require("./NearbyCommuteEstimatorState.init");
var MortgageTab_1 = require("@/pages/detail/states/MortgageTab");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var DetailVideoPlayer_init_1 = require("@/pages/detail/states/DetailVideoPlayer.init");
var DetailVideo_init_1 = require("@/pages/detail/states/DetailVideo.init");
var MortgageCommonTranslate_init_1 = require("@/pages/mortagage/states/MortgageCommonTranslate.init");
var defaultDetailState = {
    t: DetailTranslate_init_1.deafultDetailTranslate,
    tMortgage: MortgageCommonTranslate_init_1.defaultMortgageCommonTranslate,
    tFeature: BuildingState_init_1.defaultBuildingState.tFeature,
    tResult: ResultPageState_init_1.defaultResultPageState.t,
    similar: PlaceAvailableState_init_1.defaultPlaceAvailableState,
    similarViewMoreLink: '#viewmore',
    available: PlaceAvailableState_init_1.defaultPlaceAvailableState,
    availableViewMoreLink: '#viewmore',
    sameBuilding: PlaceAvailableState_init_1.defaultPlaceAvailableState,
    sameBuildingMoreLink: '#viewmore',
    property: ResultItemDetail_init_1.defaultResultItemDetail,
    mortgage: MortgageState_init_1.defaultMortgageState,
    building: DetailBuildingInfoState_init_1.defaultDetailBuildingInfoState,
    district: DetailDistrictInfoState_init_1.defaultDetailDistrictInfoState,
    nearbyMap: NearbymapState_init_1.defaultNearbymapState,
    nearbyEstimator: NearbyCommuteEstimatorState_init_1.defaultNearbyCommuteEstimatorState,
    isNearbyEstimatorShowing: false,
    agent: PropertyAgent_init_1.defaultPropertyAgent,
    gallery: DetailGalleryState_init_1.defaultDetailGalleryState,
    galleryPhotos: DetailGalleryState_init_1.defaultDetailGalleryPhotoState,
    popActiveTab: DetailPopTabType_1.DetailPopTabType.NONE,
    galleryFloorPlans: DetailGalleryState_init_1.defaultDetailGalleryFloorPlanState,
    popRender: false,
    popNearbyTab: DetailPopNearbyTabType_1.DetailPopNearbyTabType.NONE,
    mortgageTab: MortgageTab_1.MortgageTab.OVERVIEW,
    isMortgageExpand: false,
    isFeatureExpand: false,
    isSticking: false,
    isStickingContact: false,
    referringType: SfilterTypeGroup_1.SfilterType.BUY,
    buildingFollowingId: 0,
    isFeatureOverflow: false,
    navBackUrl: 'https://www.okay.com/en/property-search/map/buy/fortress-hill/rect-22.319835261721263~114.22719116055806_22.25892210189103~114.16185683944197/zm-14/em-1',
    districtFollowingId: 0,
    // unavailableInfo: defaultDetailUnavailableInfo,
    unavailableInfo: {
        title: "This property is no longer available.",
        caption: "Click HERE to search for properties!",
        link: "/en/property-search/"
    },
    videoPlayer: DetailVideoPlayer_init_1.defaultDetailVideoPlayer,
    videos: DetailVideo_init_1.defaultDetailVideos,
    showChart: true,
    showTransaction: true,
};
exports.defaultDetailState = defaultDetailState;
